export const buildStoryOptions = (stories) =>
  stories.map((story) => ({
    id: `story-${story.id}`,
    title: story.name,
    icon: 'story',
    color: `#${story.color}`,
    payload: {
      type_key: 'stories',
      object: {
        id: story.id,
      },
    },
  }))

export const buildStoryFilters = ({
  stories = [],
  groupOrAble,
  inclusivity,
}) => {
  if (stories.length === 0) {
    return null
  }

  return {
    id: 'stories',
    title: 'Stories',
    icon: 'story',
    groupOrAble,
    inclusivity,
    childOptions: buildStoryOptions(stories),
  }
}

export const storyAssociations = (filters) =>
  (filters.availableStories || []).map((story) => ({
    id: `story-${story.uuid}`,
    title: story.name,
    icon: 'story',
    color: story.color,
    payload: {
      type_key: 'assetStoryIds',
      object: {
        id: story.id,
      },
    },
  }))

export default buildStoryFilters
